// WishlistPage.jsx
import React, { useEffect } from "react";
import { Container, Box, Grid, Typography } from "@mui/material";
import AccountSidebarNav from "../../Components/AccountComponents/AccountSideNacv";
import WishlistProductCard from "../../Components/AccountComponents/WishlistProdutCard";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../State/Product/Action";
import { getWishlist } from "../../State/Wishlist/Action";
import EmptyState from "../../Components/AccountComponents/EmptyState";
import RecentReviewProductsCarousel from "../../Components/RecentReviewProductsCarousel/RecentReviewProductsCarousel";
import HomeSectionGrid from "../../Components/Home/HomeSectionGrid";

export default function Wishlist() {
    const dispatch = useDispatch();
    const jwt = localStorage.getItem("jwt");
    const { wishlist } = useSelector((store) => store);
    const products = useSelector((state) => state.products);

    useEffect(() => {
        dispatch(getAllProducts());
    }, [dispatch]);

    useEffect(() => {
        if (jwt) {
            dispatch(getWishlist());
        }
    }, [dispatch, jwt, wishlist?.addWislistItem]);

    return (
        <>
            <Container maxWidth={false} sx={{
                py: 4,
                maxWidth: {
                    xs: "100%",
                    sm: "95%",
                    md: "92%",
                    lg: "90%",
                    xl: "90%",
                },
                mx: "auto",
            }}>
                <Box
                    sx={{
                        mb: 3,
                        pb: 2,
                        borderBottom: "1px solid #ececec",
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Be Vietnam Pro', sans-serif",
                            fontSize: 12,
                            fontWeight: 300,
                            letterSpacing: "0.04em",
                            textTransform: "uppercase",
                            color: "#8a8a8a",
                        }}
                    >
                        <span>My Account</span>
                        <span style={{ margin: "0 8px", color: "#cfcfcf" }}>{">"}</span>
                        <span style={{ color: "#333" }}>My Wishlist</span>
                    </Typography>
                </Box>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={3}>
                        <AccountSidebarNav active="My Wishlist" />
                    </Grid>

                    {wishlist?.wishlistItems?.length > 0 ? (
                        <Grid item xs={12} md={9}>
                            <Typography
                                sx={{
                                    fontFamily: "'Playfair Display', Georgia, serif",
                                    fontSize: { xs: 22, md: 24 },
                                    fontWeight: 500,
                                    color: "#222",
                                    mb: 3,
                                }}
                            >
                                My Wishlist Items{" "}
                                <span
                                    style={{
                                        fontFamily: "'Be Vietnam Pro', sans-serif",
                                        fontSize: 14,
                                        fontWeight: 300,
                                        color: "#8a8a8a",
                                    }}
                                >
                                    ({wishlist?.wishlistItems?.length} products)
                                </span>
                            </Typography>

                            <Grid container spacing={3}>
                                {wishlist?.wishlistItems?.map((item, index) => (
                                    <Grid key={index} item xs={6} sm={4}>
                                        <WishlistProductCard key={item?.id} item={item?.product} />
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid item xs={12} md={9}>
                            <EmptyState
                                imageSrc="https://cdni.iconscout.com/illustration/premium/thumb/empty-wishlist-illustration-svg-download-png-9824480.png"
                                imageAlt="Empty closet"
                                title="Your Wishlist is empty!"
                                subtitle="Let's do some shopping."
                                buttonText="Start Shopping"
                                buttonHref="/"
                            />
                        </Grid>
                    )}
                </Grid>

            </Container>
            {/* recent review products  */}
            <section className="py-4 mt-5 px-1">
                <RecentReviewProductsCarousel products={products.products?.response} />
            </section>
            {/* Trending Now Section */}
            <section className="py-4 mt-3 px-1">
                <HomeSectionGrid
                    title="Trending Now"
                    viewAllLink="/trending"
                    products={products.products?.response}
                />

            </section>
        </>
    );
}
